import React, { FC } from 'react';
import { CheckCont, FlagImage, FlexibleTileDropCont } from './FlexibleDropdownTile.styles';
import CheckIcon from '@/assets/icons/checkMark.svg?react';

interface IFlexibleDropdownTile {
  item: any;
  setItem: (item: any) => void;
  active?: boolean;
}

const FlexibleDropdownTile: FC<IFlexibleDropdownTile> = ({ item, setItem, active }) => {
  const { icon, name } = item;
  return (
    <FlexibleTileDropCont
      id="FlexibleTileDropCont"
      data-testid="FlexibleDropTileEl"
      active={active}
      onClick={() => setItem(item)}
    >
      {icon && <FlagImage id="FlagImage" src={icon} />}
      {name}
      {active && (
        <CheckCont data-testid="FlexibleDropActiveMark">
          <CheckIcon />
        </CheckCont>
      )}
    </FlexibleTileDropCont>
  );
};

export default FlexibleDropdownTile;
